import { useEffect, useRef, useState } from 'react'
import dynamic from 'next/dynamic'

const LinkHoverIndicator = dynamic(() => import('./link-hover-indicator'), { ssr: false })

export default function LinkHoverGroup({ as: Tag = 'div', className, children, ...props }) {
  const groupRef = useRef(null)
  const [loadIndicator, setLoadIndicator] = useState(false)
  useEffect(() => {
    if (!window.IntersectionObserver) {
      setLoadIndicator(true)
      return
    }
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) {
        setLoadIndicator(true)
        observer.disconnect()
      }
    }, { rootMargin: '800px' })
    observer.observe(groupRef.current)
    return () => observer.disconnect()
  }, [])
  const [indicator, setIndicator] = useState({ top: 0, left: 0, width: 0, height: 0, visible: false, sliding: false })
  const highlight = (event) => {
    const link = event.target.closest('a')
    if (!link || !event.currentTarget.contains(link)) return
    setLoadIndicator(true)
    const group = event.currentTarget
    const bounds = group.getBoundingClientRect()
    const target = (link.querySelector('span') || link).getBoundingClientRect()
    const scaleX = bounds.width / group.offsetWidth
    const scaleY = bounds.height / group.offsetHeight
    setIndicator(previous => ({
      left: (target.left - bounds.left) / scaleX - 12,
      top: (target.top - bounds.top) / scaleY - 4,
      width: target.width / scaleX + 24,
      height: target.height / scaleY + 8,
      visible: true,
      sliding: previous.visible,
    }))
  }
  const hide = () => setIndicator(previous => ({ ...previous, visible: false, sliding: false }))
  return (
    <Tag
      {...props}
      ref={groupRef}
      className={`relative isolate -my-1 py-1 ${className || ''}`}
      onMouseOver={highlight}
      onMouseLeave={hide}
      onFocus={highlight}
      onBlur={event => {
        if (!event.currentTarget.contains(event.relatedTarget)) hide()
      }}
    >
      {loadIndicator && <LinkHoverIndicator {...indicator} />}
      {children}
    </Tag>
  )
}
